import { t } from '@lingui/macro'
import { CoordinatorAssignmentItem } from '@om1/aspen-api/codegen/client/models/CoordinatorAssignmentItem'
import { Card, Col, Row } from 'antd'
import { motion } from 'framer-motion'
import { useMemo } from 'react'

const getInitials = (name: string) =>
    name
        .split(' ')
        .map((part) => part[0])
        .join('')

const CoordinatorCards = ({ coordinators }: { coordinators: CoordinatorAssignmentItem[] }) => {
    const sorted = useMemo(() => {
        return [...coordinators].sort((a, b) => b.candidateCount + b.patientCount - (a.candidateCount + a.patientCount))
    }, [coordinators])

    return (
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.4 }}>
            <h3 className='text-sm font-semibold text-card-foreground mb-4'>{t`Coordinator Assignments`}</h3>
            <Row gutter={[16, 16]}>
                {sorted.map((coordinator, index) => (
                    <Col key={coordinator.id} xs={24} sm={12} lg={8}>
                        <motion.div
                            initial={{ opacity: 0, y: 8 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.6 + index * 0.05,
                                duration: 0.3
                            }}
                        >
                            <Card className='border border-gray-200 shadow-sm transition-shadow bg-white hover:shadow-md' bodyStyle={{ padding: 20 }}>
                                <div className='flex items-center gap-3 mb-4'>
                                    <div className='w-9 h-9 rounded-full bg-primary-main/10 flex items-center justify-center text-xs font-bold text-primary-main'>
                                        {getInitials(coordinator.name)}
                                    </div>
                                    <p className='font-semibold text-card-foreground text-sm'>{coordinator.name}</p>
                                </div>
                                <div className='grid grid-cols-3 gap-2 text-center'>
                                    <div>
                                        <p className='text-xs text-muted-foreground'>{t`Candidates`}</p>
                                        <p className='text-lg font-bold text-card-foreground'>{coordinator.candidateCount}</p>
                                    </div>
                                    <div>
                                        <p className='text-xs text-muted-foreground'>{t`Patients`}</p>
                                        <p className='text-lg font-bold text-card-foreground'>{coordinator.patientCount}</p>
                                    </div>
                                    <div>
                                        <p className='text-xs text-muted-foreground'>{t`Total`}</p>
                                        <p className='text-lg font-bold text-primary-main'>{coordinator.totalCount}</p>
                                    </div>
                                </div>
                            </Card>
                        </motion.div>
                    </Col>
                ))}
            </Row>
        </motion.div>
    )
}

export default CoordinatorCards
